// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4":"ca7f89c6","319":"ca7f89c6","389":"d3680f6a","501":"c0d5f668","644":"22734556"}[chunkId] + ".chunk.css";
};